import React from "react";
import "../../App.css";
import crystal from "../../crystal.jpg";
import Footer from "../Footer";

export default function Otaku() {
  return (
    <>
      <h1>Soon</h1>
      <img src={crystal} alt="ota" className="SOON" />
      <Footer />
    </>
  );
}
